/*
 * DEFINE YOUR HUES（About Us 页）
 *
 * 五件事：
 *   1. 品类列表当标签页用：点 SHADES，轮播换成 SHADES 底下那组分类卡
 *   2. 循环：滑到最后一张接着出第一张，箭头可以一直点（见下面「循环」一节）
 *   3. 桌面两颗箭头按「一张卡」翻页（scrollBy）
 *   4. 桌面鼠标可以抓着左右拖（见下面「鼠标拖拽」一节）
 *   5. 移动端进度条跟着 scrollLeft 走
 *
 * **触屏**的滚动交给原生 overflow-x + scroll-snap，不自己接管 ——
 * 自己写 pointer 事件的那套在本项目上翻过车（方向判定 + Android 的 pointercancel），
 * 原生滚动没有那些问题，也不会跟纵向滚动打架。
 * 鼠标是另一回事：原生 overflow-x 根本不支持鼠标拖拽（只能滚轮），所以那部分必须自己接，
 * 但严格限定在 `pointerType === 'mouse'`，不碰触屏。
 *
 * 关于 role：Liquid 里那几条品类是**普通链接**（href = 该品类集合页），
 * tablist / tab / tabpanel 全部由本文件在运行时补。脚本没跑起来时它就是一组能点开
 * 集合页的链接，是真的可用；如果把 role="tab" 写死在 Liquid 里，脚本一挂就变成
 * 「读屏说这是标签页、点了却整页跳走」，那是骗人。
 *
 * 循环怎么做的
 *   把这一组卡片在前后各复制若干整套，让真卡片落在中间那套，然后在「滚动停下来之后」
 *   把 scrollLeft 整套整套地平移回中间。平移前后屏幕上像素完全一样（看到的是同一批图的
 *   副本），所以用户看不见接缝。
 *
 *   两条纪律：
 *   a. 只在滚动**停下来**之后校正（140ms 静默 + 手指离开屏幕）。在惯性滚动过程中改
 *      scrollLeft 会把惯性掐断，iOS 上尤其明显 —— 那才是用户能看见的卡顿。
 *   b. 箭头翻页前先**瞬时**校正回中间，再开始平滑动画。这样动画途中永远不需要校正，
 *      不会出现动画被打断。
 *   副本数量按视口宽度算：中间那套两侧至少各留够一屏多，免得一次大力甩动就撞到尽头。
 *   撞到了也只是停住，下一次静默会把它拉回中间，不会坏。
 *
 *   副本挂 aria-hidden 且内部链接 tabindex=-1：读屏和键盘只走真卡片，不会读到重复内容。
 */
(function () {
  'use strict';

  var CLONE = 'abt-define__slide--clone';

  function init(root) {
    if (root.dataset.abtDefineReady === '1') return;
    root.dataset.abtDefineReady = '1';

    var viewport = root.querySelector('[data-abt-define-viewport]');
    var thumb = root.querySelector('[data-abt-define-thumb]');
    var prev = root.querySelector('[data-abt-define-prev]');
    var next = root.querySelector('[data-abt-define-next]');
    if (!viewport) return;

    var loopWanted = root.hasAttribute('data-abt-define-loop');
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // 当前可见面板的循环状态；不循环（卡片少到一屏放得下）时是 null
    var loop = null;
    var touching = false;
    var animatingUntil = 0;
    var idleTimer = null;
    var drag = null;        // 鼠标按下时记的基准，{id, startX, startLeft}
    var dragging = false;   // 越过阈值、真的在拖了

    /* ---------------- 循环：副本的增删与测量 ---------------- */

    function realSlides(track) {
      return Array.prototype.slice.call(track.children).filter(function (li) {
        return !li.classList.contains(CLONE);
      });
    }

    function cloneSlide(li) {
      var c = li.cloneNode(true);
      c.classList.add(CLONE);
      c.setAttribute('aria-hidden', 'true');
      // 主题编辑器靠这个属性把 DOM 和 block 对上，副本不能带 ——
      // 否则在编辑器里点到副本会去选中一个「不是它」的 block
      c.removeAttribute('data-shopify-editor-block');
      // aria-hidden 里不能留可聚焦元素，键盘 Tab 会掉进读屏读不到的地方
      Array.prototype.slice.call(c.querySelectorAll('a')).forEach(function (a) {
        a.tabIndex = -1;
      });
      return c;
    }

    function clearClones(track) {
      Array.prototype.slice.call(track.querySelectorAll('.' + CLONE)).forEach(function (c) {
        c.parentNode.removeChild(c);
      });
      track.abtCopies = 0;
    }

    function buildClones(track, slides, copies) {
      clearClones(track);
      var head = document.createDocumentFragment();
      var tail = document.createDocumentFragment();
      for (var c = 0; c < copies; c++) {
        slides.forEach(function (li) {
          head.appendChild(cloneSlide(li));
          tail.appendChild(cloneSlide(li));
        });
      }
      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);
      track.abtCopies = copies;
    }

    /*
     * 把当前面板调成该有的样子，返回循环状态（不循环则 null）。
     * 断点切换会改变「一屏放得下几张」，所以 resize 时也要重跑。
     */
    function setupLoop(track) {
      if (!track) return null;
      var slides = realSlides(track);
      var n = slides.length;
      if (!loopWanted || n < 2) {
        clearClones(track);
        return null;
      }

      var last = slides[n - 1];
      var natural = last.offsetLeft + last.offsetWidth - slides[0].offsetLeft;
      // 一屏就放得下就别循环：桌面同屏 2 张、面板正好 2 张时轮播本来就不该动
      if (natural <= viewport.clientWidth + 2) {
        clearClones(track);
        return null;
      }

      // 两侧各留够约两屏，免得一次大力甩动直接撞到尽头
      var copies = Math.max(1, Math.ceil((viewport.clientWidth * 2) / natural));
      var rebuilt = track.abtCopies !== copies;
      if (rebuilt) buildClones(track, slides, copies);

      // base = 让第一张真卡贴住左缘的 scrollLeft，也就是中间那套的起点。
      // 它跨的是 copies 整套，所以一套的宽度要再除回去 —— 直接拿这个差当 setW 会大 copies 倍。
      var base = slides[0].offsetLeft - track.children[0].offsetLeft;
      if (base <= 0) {
        clearClones(track);
        return null;
      }
      return { setW: base / copies, base: base, rebuilt: rebuilt };
    }

    /* ---------------- 位置校正 ---------------- */

    function jumpTo(x) {
      // CSS 里没有 scroll-behavior:smooth（平滑只在 scrollBy 里显式要），这里就是瞬时的
      viewport.scrollLeft = x;
    }

    function normalize(force) {
      if (!loop) return;
      if (!force && (touching || dragging || Date.now() < animatingUntil)) return;
      var k = Math.floor((viewport.scrollLeft - loop.base) / loop.setW);
      if (k === 0) return;
      jumpTo(viewport.scrollLeft - k * loop.setW);
    }

    /* ---------------- 进度条 / 箭头状态 ---------------- */

    function maxScroll() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }

    // 卡片少到一屏放得下时没什么可拖的，光标就不该变成「可抓」
    function canScroll() {
      return !!loop || maxScroll() > 2;
    }

    function sync() {
      var max = maxScroll();
      var left = viewport.scrollLeft;

      viewport.classList.toggle('is-draggable', canScroll());

      if (thumb) {
        // 拇指宽度 = 可视比例；位置按「已滚动 / 可滚动」在剩余轨道上线性分布。
        // 循环时按「一整套卡片」算，不按被副本撑长的整条轨道算 ——
        // 否则拇指会缩到 1/3 宽，而且走到头也不回头。
        var span = loop ? loop.setW : viewport.scrollWidth;
        var travel = loop ? loop.setW : max;
        var pos = loop ? ((left - loop.base) % loop.setW + loop.setW) % loop.setW : left;
        var width = Math.min(1, span > 0 ? viewport.clientWidth / span : 1) * 100;
        var offset = travel > 0 ? (pos / travel) * (100 - width) : 0;
        thumb.style.width = width + '%';
        thumb.style.left = offset + '%';
      }

      if (loop) {
        // 循环时两头都走得通，不该有禁用态
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        return;
      }

      // 2px 容差：子像素取整会让「铺满、无处可滚」的情况留出 0.x~1px 的假余量，
      // 只留 1px 容差时会出现「左箭头禁用、右箭头可点但点了不动」的割裂状态。
      // 桌面同屏正好 2 张、而 slide 也只有 2 张时 max≈0，两颗都应该是禁用态。
      if (prev) prev.disabled = max <= 2 || left <= 2;
      if (next) next.disabled = max <= 2 || left >= max - 2;
    }

    /*
     * 一次翻**一张**卡，不是一屏（桌面同屏 2 张，按屏翻一下就跳 2 张）。
     *
     * 量的是 pitch（卡左缘 → 下一张卡左缘）而不是卡宽：卡宽不含它右边的间隙，
     * 按卡宽翻每次都会差一个 gap，翻几次就错位半张。pitch 每次都落在卡的边界上。
     */
    function stepSize() {
      var track = visiblePanel();
      var kids = track ? track.children : null;
      if (!kids || !kids.length) return viewport.clientWidth;
      // 只有一张时量不出 pitch，退而用卡宽
      if (kids.length < 2) return kids[0].offsetWidth || viewport.clientWidth;
      var pitch = kids[1].offsetLeft - kids[0].offsetLeft;
      if (pitch <= 0) return kids[0].offsetWidth || viewport.clientWidth;
      return pitch;
    }

    /*
     * 翻页必须落在**绝对的卡边界**上，不能用 scrollBy 做相对位移：
     * 相对位移是从「此刻的 scrollLeft」起算的，而连点时上一次的平滑动画还没跑完、
     * 拖拽也会停在半张的位置，于是每次都带着零头往前推，点得越多偏得越狠
     * （2026-09-15 实测的累积偏移就是这么来的）。
     * 这里改成：先把当前位置四舍五入吸附到最近的一格，再整整走一格。
     */
    function page(direction) {
      // 先瞬时归位再动画：动画途中就永远不需要校正，也就不会被打断
      normalize(true);

      var pitch = stepSize();
      var anchor = loop ? loop.base : 0;
      var slot = Math.round((viewport.scrollLeft - anchor) / pitch) + direction;
      var target = anchor + slot * pitch;
      if (!loop) target = Math.max(0, Math.min(target, maxScroll()));

      viewport.scrollTo({
        left: target,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
      if (loop) animatingUntil = Date.now() + 700;
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    /* ---------------- 鼠标拖拽 ---------------- */

    /*
     * 原生 overflow-x 在触屏上能滑，鼠标却只能滚轮 —— 桌面要「抓着拖」就得自己接管。
     * 只接管 pointerType === 'mouse'：触屏照旧交给原生滚动。文件头那条「别自己接管手势」
     * 的教训针对的是触屏（方向判定 + Android 的 pointercancel），鼠标没有那些问题。
     */

    function swallowClick(event) {
      event.preventDefault();
      event.stopPropagation();
      window.removeEventListener('click', swallowClick, true);
    }

    function endDrag() {
      if (!drag) return;
      var didDrag = dragging;
      if (viewport.hasPointerCapture && viewport.hasPointerCapture(drag.id)) {
        viewport.releasePointerCapture(drag.id);
      }
      drag = null;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (!didDrag) return;
      // 松手时浏览器会在光标下那张卡上补一个 click —— 拦掉，
      // 否则「拖着看」会变成「点进了某个集合页」
      window.addEventListener('click', swallowClick, true);
      setTimeout(function () {
        window.removeEventListener('click', swallowClick, true);
      }, 300);
      normalize(false);
      sync();
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!canScroll()) return;
      drag = { id: event.pointerId, startX: event.clientX, startLeft: viewport.scrollLeft };
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.startX;
      if (!dragging) {
        // 5px 阈值：小于它按点击算，别把「点卡片进集合页」吃掉
        if (Math.abs(dx) < 5) return;
        dragging = true;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) viewport.setPointerCapture(drag.id);
      }
      event.preventDefault();
      viewport.scrollLeft = drag.startLeft - dx;

      // 拖拽没有惯性可打断，所以可以**边拖边**归位 —— 于是鼠标能一直拖下去，永远撞不到尽头。
      // 位置被平移了多少，基准也要跟着平移，不然手一动画面会跳。
      if (loop) {
        var before = viewport.scrollLeft;
        normalize(true);
        drag.startLeft += viewport.scrollLeft - before;
      }
    });

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    // 拖出窗口外再松手，pointerup 收不到
    window.addEventListener('blur', endDrag);

    // 按住图片/链接拖会触发原生的 HTML5 拖拽，那样就滚不动了
    viewport.addEventListener('dragstart', function (event) {
      if (drag) event.preventDefault();
    });

    /* ---------------- 品类标签页 ---------------- */

    var list = root.querySelector('[data-abt-define-tabs]');
    var tabs = list ? Array.prototype.slice.call(list.querySelectorAll('[data-abt-define-tab]')) : [];
    var panels = Array.prototype.slice.call(viewport.querySelectorAll('[data-abt-define-panel]'));

    function visiblePanel() {
      for (var i = 0; i < panels.length; i++) {
        if (!panels[i].hidden) return panels[i];
      }
      return null;
    }

    function refresh(resetPosition) {
      loop = setupLoop(visiblePanel());
      // 重建过副本的话原来的 scrollLeft 已经不指向原来那张卡了，必须回起点
      if (resetPosition || (loop && loop.rebuilt)) jumpTo(loop ? loop.base : 0);
      sync();
    }

    function panelOf(tab) {
      return document.getElementById(tab.getAttribute('data-panel') || '');
    }

    function select(tab, moveFocus) {
      var target = panelOf(tab);

      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        // roving tabindex：整组标签在 Tab 键序里只占一个位置，组内用方向键走
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
      });

      // 按面板本身开关，不按 tab 一一对应 —— 没配自己卡片的几个品类共用同一条兜底面板，
      // 一一对应的话会先把它显示再把它藏起来。
      panels.forEach(function (p) {
        p.hidden = p !== target;
      });

      if (target) {
        target.setAttribute('aria-labelledby', tab.id);
        // 换了一组图：重新算这组的循环副本，并把位置退回起点
        refresh(true);
      }

      if (moveFocus) tab.focus();
    }

    function onTabKeydown(event) {
      var i = tabs.indexOf(event.currentTarget);
      var to = null;
      // 列表在两端都是竖排，所以上下键是主用法；左右键一并支持，符合 APG 的 tablist 约定
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') to = (i + 1) % tabs.length;
      else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') to = (i - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') to = 0;
      else if (event.key === 'End') to = tabs.length - 1;
      if (to === null) return;
      event.preventDefault();
      select(tabs[to], true);
    }

    if (tabs.length && panels.length) {
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-orientation', 'vertical');
      // role=tablist 的直接子元素必须是 tab，中间夹的 <li> 要摘掉列表项语义
      Array.prototype.slice.call(list.children).forEach(function (li) {
        li.setAttribute('role', 'presentation');
      });

      panels.forEach(function (p) {
        p.setAttribute('role', 'tabpanel');
        // 面板里只有链接卡，本身不可聚焦的话键盘用户从标签跳不进内容
        p.setAttribute('tabindex', '0');
      });

      tabs.forEach(function (tab) {
        var panel = panelOf(tab);
        tab.setAttribute('role', 'tab');
        if (panel) tab.setAttribute('aria-controls', panel.id);

        tab.addEventListener('click', function (event) {
          // ctrl / cmd / shift / 中键保持原生「在新标签页打开这个品类集合页」的行为
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
          if (!panel) return; // 面板不存在就别拦，让它照常跳集合页
          event.preventDefault();
          select(tab, false);
        });
        tab.addEventListener('keydown', onTabKeydown);
      });

      // 初始选中：Liquid 已经把第一条标成 is-active、并把对应面板显示出来了，
      // 这里只是把 aria 状态补齐，顺带兜住「第一条对应的面板不存在」的情况。
      var initial = null;
      for (var n = 0; n < tabs.length; n++) {
        if (panelOf(tabs[n])) { initial = tabs[n]; break; }
      }
      if (initial) select(initial, false);
    }

    /* ---------------- 滚动状态 ---------------- */

    viewport.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    viewport.addEventListener('touchend', function () { touching = false; }, { passive: true });
    viewport.addEventListener('touchcancel', function () { touching = false; }, { passive: true });

    var ticking = false;
    viewport.addEventListener(
      'scroll',
      function () {
        // 校正只在滚动静默之后做，不在滚动过程中做 —— 见文件头「两条纪律」
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () {
          normalize(false);
          sync();
        }, 140);

        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          sync();
        });
      },
      { passive: true }
    );

    if (window.ResizeObserver) {
      // 断点切换时 clientWidth / scrollWidth 都会变：拇指宽度、按钮可用性、
      // 以及「要不要循环、要几套副本」都得重算
      new ResizeObserver(function () { refresh(false); }).observe(viewport);
    } else {
      window.addEventListener('resize', function () { refresh(false); });
    }

    refresh(true);

    // 图片是 lazy 的，加载完之后卡片尺寸才定下来，套宽要重量一次
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { refresh(false); }, { once: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-abt-define]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 主题编辑器里重新加载 section 后要重新绑定
  document.addEventListener('shopify:section:load', boot);
})();
